// ── 정산DOT 수입 섹션 (카드승인·카드업로드·전화승인·입금) ──────────────────────
// StoreCard.jsx에서 분리 — expanded 상태의 수입 섹션 전용 렌더링

import React from 'react';
import { C } from './constants';
import { fmt, fmtDate } from './utils';
import { s } from './mobileStyles';
import { DetailSection, UnlinkBtn } from './StoreCardDetail';

export function StoreCardIncomeDetails({ plus, onUnlink }) {
  return (
    <>
      {/* 카드승인 (수동 입력 — dot_revenue_cards) */}
      {plus.cards.length > 0 && (
        <DetailSection label="카드승인" total={plus.cardTotal} color={C.plus} sign="+">
          {plus.cards.map((c) => (
            <div key={c.id} style={s.dRow}>
              <div style={s.dLine}>
                <span style={s.dDate}>{fmtDate(c.transactionDate)}</span>
                <span style={s.payName}>{c.cardIssuer || c.merchantName || '—'}</span>
                <span style={s.dOrigAmt}>{fmt(c.amount)}원</span>
                <UnlinkBtn onClick={() => onUnlink('card', c.id)} />
                <span style={{ flex: 1 }} />
                <span style={{ ...s.dAmt, color: C.plus }}>+{fmt(c.commission)}</span>
              </div>
            </div>
          ))}
        </DetailSection>
      )}

      {/* 카드업로드 (엑셀 업로드 — revenue_dot_card_approvals 등) */}
      {plus.cardUploads && plus.cardUploads.length > 0 && (
        <DetailSection label="카드업로드" total={plus.cardUploadTotal} color={C.plus} sign="+">
          {plus.cardUploads.map((c) => (
            <div key={c.id} style={s.dRow}>
              <div style={s.dLine}>
                <span style={s.dDate}>{fmtDate(c.transactionDate)}</span>
                <span style={s.payName}>{c.cardIssuer || c.merchantName || '—'}</span>
                <span style={s.dOrigAmt}>{fmt(c.amount)}원</span>
                <UnlinkBtn onClick={() => onUnlink('card_upload', c.id)} />
                <span style={{ flex: 1 }} />
                <span style={{ ...s.dAmt, color: C.plus }}>+{fmt(c.commission)}</span>
              </div>
            </div>
          ))}
        </DetailSection>
      )}

      {/* 전화승인 */}
      {plus.phones.length > 0 && (
        <DetailSection label="전화승인" total={plus.phoneTotal} color={C.plus} sign="+">
          {plus.phones.map((p) => (
            <div key={p.id} style={s.dRow}>
              <div style={s.dLine}>
                <span style={s.dDate}>{fmtDate(p.paymentDate)}</span>
                <span style={s.payName}>{p.cardCompany || '—'}</span>
                <span style={s.dOrigAmt}>{fmt(p.amount)}원</span>
                <UnlinkBtn onClick={() => onUnlink('phone', p.id)} />
                <span style={{ flex: 1 }} />
                <span style={{ ...s.dAmt, color: C.plus }}>+{fmt(p.commission)}</span>
              </div>
              {p.note && <div style={s.dSub2}><span style={s.payInfoChip}>{p.note}</span></div>}
            </div>
          ))}
        </DetailSection>
      )}

      {/* 입금 */}
      {plus.deposits.length > 0 && (
        <DetailSection label="입금" total={plus.depositTotal} color={C.plus} sign="+">
          {plus.deposits.map((d) => (
            <div key={d.id} style={s.dRow}>
              <div style={s.dLine}>
                <span style={s.dDate}>{fmtDate(d.paymentDate)}</span>
                <span style={s.payName}>{d.payerName || '—'}</span>
                <span style={s.dOrigAmt}>{fmt(d.amount)}원</span>
                <UnlinkBtn onClick={() => onUnlink('payments', d.id)} />
                <span style={{ flex: 1 }} />
                <span style={{ ...s.dAmt, color: C.plus }}>+{fmt(d.commission)}</span>
              </div>
              <div style={s.dSub2}>
                {d.taxInvoiceLinked && d.taxInvoice
                  ? <span style={s.taxChip}>{d.taxInvoice.issueType || '영수'}계산서</span>
                  : <span style={s.unlinkChip}>미연결</span>
                }
              </div>
            </div>
          ))}
        </DetailSection>
      )}
    </>
  );
}
